import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-2">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-[#2563EB]' : 'text-gray-900 group-hover:text-[#2563EB]'}`} data-id="element-3">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-[#2563EB]" data-id="element-4" /> : <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-[#2563EB]" data-id="element-5" />}
      </button>
      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-7">
            <p className="pb-6 text-gray-600 leading-relaxed" data-id="element-8">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}